
import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/module'
import FooterBlock from '@/components/FooterBlock.vue'
import ContactBlock from '@/components/ContactBlock.vue'
import QuestionBlock from '@/components/QuestionBlock.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'

import Banner from './components/Banner.vue'
import HelpBlock from '@/components/HelpBlock.vue'

import { scrollToElem } from '@/utils/scroll'

@Component({
  components: {
    Banner,
    FooterBlock,
    ContactBlock,
    QuestionBlock,
    HelpBlock,
    Breadcrumb,
  },
})
export default class Program extends Vue {
  showContact = true

  breadcrumbMap: Record<string, { label: string; to?: string }[]> = {
    snacks: [{ label: '首頁', to: '/' }, { label: '5大餐廳類型' }, { label: '咖啡/飲品/快餐店' }],
    pasta: [{ label: '首頁', to: '/' }, { label: '5大餐廳類型' }, { label: '車仔麵/米線店' }],
    restaurant: [{ label: '首頁', to: '/' }, { label: '5大餐廳類型' }, { label: '茶餐廳/冰室/西餐廳' }],
    foodcourt: [{ label: '首頁', to: '/' }, { label: '5大餐廳類型' }, { label: 'Foodcourt' }],
    takeaway: [{ label: '首頁', to: '/' }, { label: '5大餐廳類型' }, { label: '中央廚房/虛擬餐廳' }],
  }

  get breadcrumbItems() {
    return this.breadcrumbMap[this.$route.name as string] || []
  }

  bannerMap = {
    'snacks': {
      imgH5: require('@/assets/program/snacks-banner-h5-clean.png'),
      mobileCopy: true,
      imgPc: require('@/assets/program/snacks-banner-pc.jpg'),
      alt: '飲品店/咖啡店/快餐店/外賣店',
      title: '飲品店/咖啡店\n快餐店/外賣店',
      subtitle: 'Pin Me 智慧「雲餐廳」解決方案',
    },
    'pasta': {
      imgH5: require('@/assets/program/pasta-banner-h5-clean.png'),
      mobileCopy: true,
      imgPc: require('@/assets/program/pasta-banner-pc.jpg'),
      alt: '車仔麵店/米線店/中式粉麵店',
      title: '車仔麵店/米線店\n中式粉麵店',
      subtitle: 'Pin Me 智慧「雲餐廳」解決方案',
    },
    'restaurant': {
      imgH5: require('@/assets/program/restaurant-banner-h5-clean.png'),
      mobileCopy: true,
      mobileTitleWidth: '90%',
      imgPc: require('@/assets/program/restaurant-banner-pc.jpg'),
      alt: '茶餐廳/冰室/西餐廳/酒樓/中菜館',
      title: '茶餐廳/冰室\n西餐廳/酒樓/中菜館',
      titleWidth: '36%',
      subtitle: 'Pin Me 智慧「雲餐廳」解決方案',
    },
    'foodcourt': {
      imgH5: require('@/assets/program/foodcourt-banner-h5-clean.png'),
      mobileCopy: true,
      imgPc: require('@/assets/program/foodcourt-banner-pc.jpg'),
      alt: 'Foodcourt',
      title: 'Foodcourt\n美食廣場',
      subtitle: 'Pin Me 智慧「雲餐廳」解決方案',
    },
    'takeaway': {
      imgH5: require('@/assets/program/takeaway-banner-h5-clean.png'),
      mobileCopy: true,
      imgPc: require('@/assets/program/takeaway-banner-pc.jpg'),
      alt: '中央廚房+外賣自取點/外賣送餐',
      title: '中央廚房\n虛擬餐廳',
      subtitle: 'Pin Me 智慧「雲餐廳」解決方案',
    },
  }

  get bannerData() {
    return this.bannerMap[this.$route.name]
  }

  get isH5() {
    return AppModule.isH5
  }

  contactHeight = 0
  footerHeight = 0
  screenHeight = 0
  bodyHeight = 0

  mounted() {
    this.contactHeight = (this.$refs.contact as Vue & { $el: HTMLElement }).$el.offsetHeight
    this.footerHeight = (this.$refs.footer as Vue & { $el: HTMLElement }).$el.offsetHeight
    this.screenHeight = document.documentElement.clientHeight
    window.addEventListener('scroll', this.scrollHandle)
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollHandle)
  }

  scrollHandle() {
    const scrollTop = document.documentElement.scrollTop
    if (!this.bodyHeight) {
      this.bodyHeight = document.body.offsetHeight
    }
    if (scrollTop >= this.bodyHeight - this.screenHeight - this.footerHeight - this.contactHeight) {
      this.showContact = false
    } else {
      this.showContact = true
    }
  }

  scrollToContact() {
    scrollToElem('#contact', 500, 80)
  }
}
